import { render, staticRenderFns } from "./Informativos.vue?vue&type=template&id=4f5febd4&scoped=true&"
import script from "./Informativos.vue?vue&type=script&lang=js&"
export * from "./Informativos.vue?vue&type=script&lang=js&"
import style0 from "./Informativos.vue?vue&type=style&index=0&id=4f5febd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5febd4",
  null
  
)

export default component.exports